<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <v-toolbar color="#37474F" dark class="flex-wrap">
                <v-toolbar-title>이벤트 롤링 관리</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="cyan"
                    small
                    fab
                    @click="OnClick_CreateEventRolling"
                >
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
            </v-toolbar>

            <v-list>
                <v-container v-if="loadingData" class="text-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-container>
                <v-row v-else>
                    <v-col
                        v-for="item in event_rolling_list"
                        :key="item.PID"
                        cols="12"
                        md="6"
                        lg="4"
                    >
                        <v-card
                            class="mx-auto"
                            :elevation="isEventActive(item) ? 2 : 1"
                            @click="OnClick_EditEventRolling(item)"
                            style="cursor: pointer;"
                            :class="{'grey-lighten-4': !isEventActive(item)}"
                        >
                            <v-img
                                v-if="item.THUMB"
                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.THUMB"
                                height="150"
                                cover
                                :style="!isEventActive(item) ? 'filter: grayscale(100%); opacity: 0.6;' : ''"
                            >
                                <template v-slot:placeholder>
                                    <div class="d-flex align-center justify-center fill-height">
                                        <v-progress-circular
                                            color="grey-lighten-4"
                                            indeterminate
                                        ></v-progress-circular>
                                    </div>
                                </template>
                            </v-img>
                            <v-card-title 
                                :class="isEventActive(item) ? 'primary white--text' : 'grey darken-1 white--text'"
                            >
                                <v-icon left color="white">mdi-calendar-clock</v-icon>
                                {{ item.TITLE }}
                            </v-card-title>
                            
                            <v-card-text :class="!isEventActive(item) ? 'grey--text text--darken-1' : ''" style="max-width: 100%; overflow-wrap: break-word;">
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'primary' : 'grey'" class="mr-1">mdi-tag</v-icon>
                                    <span class="text-body-2 font-weight-medium">이벤트 태그:</span>
                                    <span class="text-body-2 ml-2">{{ item.EVENT_TAG }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'info' : 'grey'" class="mr-1">mdi-text</v-icon>
                                    <span class="text-body-2 font-weight-medium">설명:</span>
                                    <span class="text-body-2 ml-2">{{ item.DESC }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'success' : 'grey'" class="mr-1">mdi-calendar-start</v-icon>
                                    <span class="text-body-2 font-weight-medium">시작일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.START_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'error' : 'grey'" class="mr-1">mdi-calendar-end</v-icon>
                                    <span class="text-body-2 font-weight-medium">종료일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.END_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="item.IS_ENABLE === 'Y' ? (isEventActive(item) ? 'success' : 'grey') : 'error'" class="mr-1">
                                        {{ item.IS_ENABLE === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                    </v-icon>
                                    <span class="text-body-2 font-weight-medium">활성화:</span>
                                    <span class="text-body-2 ml-2">{{ item.IS_ENABLE === 'Y' ? '활성화' : '비활성화' }}</span>
                                </div>
                                <div class="mt-3" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                                    <span class="text-caption grey--text">생성일: {{ formatDate(item.CREATE_DT) }}</span>
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    small
                                    outlined
                                    @click.stop="OnClick_EditEventRolling(item)"
                                >
                                    <v-icon small left>mdi-pencil</v-icon>
                                    수정
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-container v-if="!loadingData && event_rolling_list.length === 0" class="text-center">
                    <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                    <p class="text-body-1 grey--text mt-2">등록된 이벤트 롤링이 없습니다.</p>
                </v-container>
            </v-list>
        </v-card>

        <!-- 이벤트 롤링 생성/수정 다이얼로그 -->
        <v-dialog
            v-model="dialog_event_rolling"
            persistent
            max-width="900"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            @keydown.esc="CloseEventRollingDialog"
        >
            <v-card>
                <v-card-title class="text-h5 primary white--text">
                    <v-icon left color="white">{{ dialog_mode_edit ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
                    {{ dialog_mode_edit ? '이벤트 롤링 수정' : '이벤트 롤링 등록' }}
                </v-card-title>

                <v-card-text class="pa-6">
                    <!-- 기본 정보 섹션 -->
                    <div class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                            <h3 class="text-h6 font-weight-bold">기본 정보</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="4">
                                <div class="mb-3">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">썸네일 이미지</label>
                                    <v-img
                                        v-if="dialog_thumb_url"
                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + dialog_thumb_url"
                                        alt="썸네일 미리보기"
                                        style="width: 100%; height: 150px; object-fit: cover; border-radius: 8px; border: 2px solid #e0e0e0;"
                                        class="mb-3"
                                    />
                                    <v-file-input
                                        label="이미지 선택"
                                        accept="image/*"
                                        v-model="dialog_thumb_file"
                                        prepend-icon="mdi-image"
                                        outlined
                                        dense
                                        hide-details
                                        @change="handleFileChange"
                                    />
                                </div>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field
                                    v-model="dialog_event_tag"
                                    label="이벤트 태그 *"
                                    outlined
                                    dense
                                    class="mb-3"
                                    maxlength="50"
                                    counter
                                    prepend-inner-icon="mdi-tag"
                                    :rules="[v => !!v || '이벤트 태그를 입력해주세요']"
                                />
                                <v-text-field
                                    v-model="dialog_title"
                                    label="제목 *"
                                    outlined
                                    dense
                                    class="mb-3"
                                    maxlength="100"
                                    counter
                                    prepend-inner-icon="mdi-format-title"
                                    :rules="[v => !!v || '제목을 입력해주세요']"
                                />
                                <v-textarea
                                    v-model="dialog_desc"
                                    label="설명 *"
                                    outlined
                                    dense
                                    rows="3"
                                    prepend-inner-icon="mdi-text"
                                    :rules="[v => !!v || '설명을 입력해주세요']"
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- 기간 설정 섹션 -->
                    <div class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-calendar-clock</v-icon>
                            <h3 class="text-h6 font-weight-bold">기간 설정</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">시작일시 *</label>
                                </div>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            v-model="dialog_start_dt_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_dt"
                                                    label="날짜"
                                                    prepend-inner-icon="mdi-calendar-start"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    :rules="[v => !!v || '시작일을 선택해주세요']"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dialog_start_dt"
                                                @input="dialog_start_dt_menu = false"
                                                locale="ko-KR"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="dialog_start_time_menu"
                                            v-model="dialog_start_time_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="dialog_start_time"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_time"
                                                    label="시간"
                                                    prepend-inner-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="dialog_start_time_menu"
                                                v-model="dialog_start_time"
                                                full-width
                                                format="24hr"
                                                @click:minute="$refs.dialog_start_time_menu.save(dialog_start_time)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">종료일시 *</label>
                                </div>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            v-model="dialog_end_dt_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_dt"
                                                    label="날짜"
                                                    prepend-inner-icon="mdi-calendar-end"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    :rules="[v => !!v || '종료일을 선택해주세요']"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dialog_end_dt"
                                                @input="dialog_end_dt_menu = false"
                                                locale="ko-KR"
                                                :min="dialog_start_dt"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="dialog_end_time_menu"
                                            v-model="dialog_end_time_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="dialog_end_time"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_time"
                                                    label="시간"
                                                    prepend-inner-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="dialog_end_time_menu"
                                                v-model="dialog_end_time"
                                                full-width
                                                format="24hr"
                                                @click:minute="$refs.dialog_end_time_menu.save(dialog_end_time)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- 설정 섹션 -->
                    <div class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-cog</v-icon>
                            <h3 class="text-h6 font-weight-bold">설정</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dialog_is_enable"
                                    :items="yes_no_options"
                                    item-text="label"
                                    item-value="value"
                                    label="활성화 여부"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-toggle-switch"
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- 추가 정보 섹션 -->
                    <div class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-code-json</v-icon>
                            <h3 class="text-h6 font-weight-bold">추가 정보 (선택사항)</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-textarea
                            v-model="dialog_info_text"
                            label="정보 (JSON 형식)"
                            outlined
                            dense
                            rows="5"
                            prepend-inner-icon="mdi-code-json"
                            hint="JSON 형식으로 입력하세요. 예: {&quot;key&quot;: &quot;value&quot;}"
                            persistent-hint
                        />
                    </div>
                </v-card-text>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="CloseEventRollingDialog"
                    >
                        취소
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="OnSave_EventRolling"
                        :loading="loadingData"
                    >
                        저장
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { FileUpload_Async } = require("../../util/fileutil");

export default {
    name: 'Game_EventRolling',

    data: () => ({
        loadingData: false,
        event_rolling_list: [],
        dialog_event_rolling: false,
        dialog_mode_edit: false,
        dialog_event_tag: '',
        dialog_title: '',
        dialog_desc: '',
        dialog_thumb_file: null,
        dialog_thumb_url: '',
        dialog_start_dt: '',
        dialog_start_time: '00:00',
        dialog_end_dt: '',
        dialog_end_time: '23:59',
        dialog_is_enable: 'Y',
        dialog_info_text: '',
        dialog_start_dt_menu: false,
        dialog_start_time_menu: false,
        dialog_end_dt_menu: false,
        dialog_end_time_menu: false,
        selected_event_rolling_pid: null,
        yes_no_options: [
            { label: '활성화', value: 'Y' },
            { label: '비활성화', value: 'N' }
        ],
    }),

    created() {
        this.LoadEventRollingList();
    },

    methods: {
        ...mapActions([
            'QUIZNCASH_GET_EVENT_ROLLING_LIST',
            'QUIZNCASH_CREATE_EVENT_ROLLING',
            'QUIZNCASH_EDIT_EVENT_ROLLING',
        ]),

        LoadEventRollingList() {
            this.loadingData = true;
            this.QUIZNCASH_GET_EVENT_ROLLING_LIST({})
                .then((body_data) => {
                    this.loadingData = false;
                    // 여러 응답 구조를 대비한 파싱
                    this.event_rolling_list = body_data.event_rolling_list 
                        || body_data.response_data?.event_rolling_list 
                        || (body_data.response_data && Array.isArray(body_data.response_data) ? body_data.response_data : [])
                        || [];
                    console.log('이벤트 롤링 리스트 로드:', this.event_rolling_list);
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('이벤트 롤링 리스트 로드 실패:', err);
                    alert('이벤트 롤링 리스트를 불러오는데 실패했습니다.');
                });
        },

        OnClick_CreateEventRolling() {
            this.dialog_mode_edit = false;
            this.selected_event_rolling_pid = null;
            this.dialog_event_tag = '';
            this.dialog_title = '';
            this.dialog_desc = '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = '';
            this.dialog_start_dt = '';
            this.dialog_start_time = '00:00';
            this.dialog_end_dt = '';
            this.dialog_end_time = '23:59';
            this.dialog_is_enable = 'Y';
            this.dialog_info_text = '';
            this.dialog_event_rolling = true;
        },

        OnClick_EditEventRolling(item) {
            this.dialog_mode_edit = true;
            this.selected_event_rolling_pid = item.PID;
            this.dialog_event_tag = item.EVENT_TAG || '';
            this.dialog_title = item.TITLE || '';
            this.dialog_desc = item.DESC || '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = item.THUMB || '';
            
            // 날짜와 시간 분리
            if (item.START_DT) {
                const startParts = item.START_DT.split(' ');
                this.dialog_start_dt = startParts[0] || '';
                this.dialog_start_time = startParts[1] ? startParts[1].substring(0, 5) : '00:00';
            } else {
                this.dialog_start_dt = '';
                this.dialog_start_time = '00:00';
            }
            
            if (item.END_DT) {
                const endParts = item.END_DT.split(' ');
                this.dialog_end_dt = endParts[0] || '';
                this.dialog_end_time = endParts[1] ? endParts[1].substring(0, 5) : '23:59';
            } else {
                this.dialog_end_dt = '';
                this.dialog_end_time = '23:59';
            }
            
            this.dialog_is_enable = item.IS_ENABLE || 'Y';
            
            // INFO가 JSON 문자열인 경우 파싱하여 보기 좋게 표시
            if (item.INFO) {
                try {
                    const parsed = typeof item.INFO === 'string' ? JSON.parse(item.INFO) : item.INFO;
                    this.dialog_info_text = JSON.stringify(parsed, null, 2);
                } catch (e) {
                    this.dialog_info_text = item.INFO;
                }
            } else {
                this.dialog_info_text = '';
            }
            
            this.dialog_event_rolling = true;
        },

        handleFileChange(file) {
            // 파일 선택 시 처리
        },

        async OnSave_EventRolling() {
            // 필수 필드 검증
            if (!this.dialog_event_tag || !this.dialog_title || !this.dialog_desc || !this.dialog_start_dt || !this.dialog_end_dt) {
                alert('필수 항목(이벤트 태그, 제목, 설명, 시작일, 종료일)을 모두 입력해주세요.');
                return;
            }

            // 썸네일 검증 (생성 시에만 필수)
            if (!this.dialog_mode_edit && !this.dialog_thumb_file) {
                alert('썸네일 이미지를 선택해주세요.');
                return;
            }

            // 날짜와 시간 결합
            const start_dt = `${this.dialog_start_dt} ${this.dialog_start_time}:00`;
            const end_dt = `${this.dialog_end_dt} ${this.dialog_end_time}:00`;

            // 날짜/시간 검증
            const startDateTime = new Date(start_dt);
            const endDateTime = new Date(end_dt);
            if (startDateTime >= endDateTime) {
                alert('시작일시가 종료일시보다 늦거나 같을 수 없습니다.');
                return;
            }

            this.loadingData = true;

            let thumb_url = this.dialog_thumb_url;

            // 새 이미지가 업로드된 경우
            if (this.dialog_thumb_file) {
                // 파일 크기 체크 (1MB = 1048576 bytes)
                const maxFileSize = 1024 * 1024; // 1MB
                if (this.dialog_thumb_file.size > maxFileSize) {
                    this.loadingData = false;
                    alert('파일 크기가 1MB를 초과합니다. 더 작은 파일을 선택해주세요.');
                    return;
                }

                thumb_url = "project_quizncash/images/eventrolling/banner/" + this.Utill_CreateNewImageName(this.dialog_thumb_file.name);
                try {
                    await FileUpload_Async(this.dialog_thumb_file, thumb_url);
                } catch (error) {
                    this.loadingData = false;
                    console.error('이미지 업로드 실패:', error);
                    alert('이미지 업로드에 실패했습니다.');
                    return;
                }
            }

            // INFO 파싱
            let info = null;
            if (this.dialog_info_text && this.dialog_info_text.trim()) {
                try {
                    info = JSON.parse(this.dialog_info_text);
                } catch (e) {
                    this.loadingData = false;
                    alert('정보 필드가 올바른 JSON 형식이 아닙니다.');
                    return;
                }
            }

            if (this.dialog_mode_edit) {
                // 수정 모드
                this.QUIZNCASH_EDIT_EVENT_ROLLING({
                    pid: this.selected_event_rolling_pid,
                    event_tag: this.dialog_event_tag,
                    title: this.dialog_title,
                    desc: this.dialog_desc,
                    thumb: thumb_url,
                    start_dt: start_dt,
                    end_dt: end_dt,
                    is_enable: this.dialog_is_enable,
                    info: info
                })
                .then((response) => {
                    this.loadingData = false;
                    alert('이벤트 롤링이 수정되었습니다.');
                    this.CloseEventRollingDialog();
                    this.LoadEventRollingList();
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('이벤트 롤링 수정 실패:', err);
                    alert('이벤트 롤링 수정에 실패했습니다: ' + (err || '알 수 없는 오류'));
                });
            } else {
                // 생성 모드
                this.QUIZNCASH_CREATE_EVENT_ROLLING({
                    event_tag: this.dialog_event_tag,
                    title: this.dialog_title,
                    desc: this.dialog_desc,
                    thumb: thumb_url,
                    start_dt: start_dt,
                    end_dt: end_dt,
                    is_enable: this.dialog_is_enable,
                    info: info
                })
                .then((response) => {
                    this.loadingData = false;
                    alert('이벤트 롤링이 등록되었습니다.');
                    this.CloseEventRollingDialog();
                    this.LoadEventRollingList();
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('이벤트 롤링 생성 실패:', err);
                    alert('이벤트 롤링 등록에 실패했습니다: ' + (err || '알 수 없는 오류'));
                });
            }
        },

        CloseEventRollingDialog() {
            this.dialog_event_rolling = false;
            this.dialog_mode_edit = false;
            this.selected_event_rolling_pid = null;
        },

        Utill_CreateNewImageName(originalFileName) {
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
            const randomString = Math.random().toString(36).substring(2, 18);
            return randomString + fileExtension;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        isEventActive(item) {
            if(item.IS_ENABLE == 'N'){
                return false;
            }
            // 기간 체크만 수행 (활성화 여부와 무관하게 현재 시간이 기간 내에 있는지 확인)
            const now = new Date();
            
            // START_DT와 END_DT가 이미 날짜+시간 형식이므로 그대로 사용
            const startDate = new Date(item.START_DT);
            const endDate = new Date(item.END_DT);

            // 날짜 파싱이 실패한 경우 처리
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                console.error('날짜 파싱 실패:', item.START_DT, item.END_DT);
                return false;
            }

            // 현재 시간이 시작일시 이후이고 종료일시 이전인지 확인
            return now >= startDate && now <= endDate;
        }
    },

    computed: {
        isLive() {
            return config.isLive;
        }
    }
};
</script>

